import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const revealLine = {
  hidden: { y: "115%" },
  show: (i) => ({
    y: "0%",
    transition: { duration: 0.9, delay: 0.2 + i * 0.14, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function Hero() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const textY = useTransform(scrollYProgress, [0, 1], [0, 55]);
  const fade = useTransform(scrollYProgress, [0, 0.75], [1, 0]);

  return (
    <section ref={ref} className="pt-32 sm:pt-36 pb-12 relative" data-testid="hero-section">
      <motion.div style={{ y: textY, opacity: fade }} className="relative">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.1, duration: 0.6 }}
          className="font-jetmono text-[10px] sm:text-[11px] tracking-[0.35em] text-[#00f0ff] mb-4"
        >
          REGISTRO VEICOLI ITALIA — ACCESSO ISTANTANEO
        </motion.p>
        <h1 className="font-orbitron font-black uppercase leading-[1.08] text-4xl sm:text-6xl tracking-wide">
          <span className="block overflow-hidden pb-1">
            <motion.span custom={0} variants={revealLine} initial="hidden" animate="show" className="block">
              LA VERITÀ
            </motion.span>
          </span>
          <span className="block overflow-hidden pb-2">
            <motion.span custom={1} variants={revealLine} initial="hidden" animate="show" className="block">
              DIETRO <span className="text-[#ff007f]">OGNI TARGA.</span>
            </motion.span>
          </span>
        </h1>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.65, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="text-sm sm:text-base text-[#8a8a9e] leading-relaxed mt-5 max-w-[46ch]"
        >
          Inserisci la targa per identificare subito il veicolo e sbloccare il report tecnico completo:
          motore, storico chilometrico, revisioni e RCA.
        </motion.p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.15, duration: 0.8 }}
        className="mt-8 grid grid-cols-3 gap-3"
      >
        {[
          ["35,00 €", "REPORT UNICO"],
          ["2 SEC", "SCANSIONE TARGA"],
          ["24/7", "REGISTRO ATTIVO"],
        ].map(([v, l]) => (
          <div key={l} className="text-center border border-white/5 rounded-xl py-3 bg-[#0c0c10]/60">
            <div className="font-orbitron font-bold text-sm sm:text-base text-[#00f0ff]">{v}</div>
            <div className="font-jetmono text-[8px] sm:text-[9px] tracking-[0.2em] text-[#8a8a9e] mt-1">{l}</div>
          </div>
        ))}
      </motion.div>
    </section>
  );
}
